// src/config.js
let config = {
	REACT_APP_WEB_LINK: '',
	REACT_APP_IMG_UPLOAD_LINK: '',
	REACT_APP_REDIRECT_CUSTOMER_LINK: '',
	REACT_APP_REDIRECT_EMPLOYEE_LINK: '',
	REACT_APP_DUE_DATE_STATUS: '',
};

export const loadConfig = async () => {
	const response = await fetch('/config.json');
	const json = await response.json();
	config = json;

	const isLocalhost = window.location.hostname === 'localhost';

	config.REACT_APP_WEB_LINK = config.REACT_APP_WEB_LINK.replace(
		'[host]',
		isLocalhost ? 'https://controlpanel.schedulerdesk.com/' : window.location.origin,
	);
	config.REACT_APP_IMG_UPLOAD_LINK = config.REACT_APP_IMG_UPLOAD_LINK.replace(
		'[host]',
		isLocalhost ? 'https://controlpanel.schedulerdesk.com/' : window.location.origin,
	);
};

export const getConfig = () => config;
